import { render, staticRenderFns } from "./reviewHistory.vue?vue&type=template&id=21409db5&scoped=true&"
import script from "./reviewHistory.vue?vue&type=script&lang=js&"
export * from "./reviewHistory.vue?vue&type=script&lang=js&"
import style0 from "./reviewHistory.vue?vue&type=style&index=0&id=21409db5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21409db5",
  null
  
)

export default component.exports